<ng-container *transloco="let t">
    <form [formGroup]="projectHeadingForm" (ngSubmit)="onProjectHeadingFormSubmit()">
        <div class="modal-header">
            @if (action === 0) {
                {{ t('IDS_NEW_PROJECT') }}
            } @else {
                {{ t('IDS_EDIT_PROJECT') }}
            }
        </div>
        <div class="modal-body py-0">
                <div class="mt-8 pt-20">
                    <label for="title" class="form-label">{{ t('IDS_PROJECT_TITLE') }}</label>
                    <input type="text" id="title" class="form-control form-control--inverted" [class.is-invalid]="projectHeadingForm.controls.title.invalid && (projectHeadingForm.controls.title.dirty || projectHeadingForm.controls.title.touched)" formControlName="title" [placeholder]="t('IDS_PROJECT_TITLE_PLACEHOLDER')">
                    @if (projectHeadingForm.controls.title.invalid && (projectHeadingForm.controls.title.dirty || projectHeadingForm.controls.title.touched) && projectHeadingForm.controls.title.hasError('required')) {
                        <div class="invalid-feedback" >
                            {{ t('IDS_REQUIRED_ERROR_FIELD') }}
                        </div>
                    }
                </div>
                <div class="mt-8 pt-20">
                    <label for="customer" class="form-label">{{ t('IDS_CUSTOMER') }}</label>
                    <select id="customer" class="form-select form-select--inverted" [class.is-invalid]="projectHeadingForm.controls.idCustomer.invalid && (projectHeadingForm.controls.idCustomer.dirty || projectHeadingForm.controls.idCustomer.touched)" formControlName="idCustomer">
                        @for (customer of customersLookupOptions; track customer.key) {
                            <option [ngValue]="customer.key">{{ customer.value }}</option>
                        }
                    </select>
                    @if (projectHeadingForm.controls.idCustomer.invalid && (projectHeadingForm.controls.idCustomer.dirty || projectHeadingForm.controls.idCustomer.touched) && projectHeadingForm.controls.idCustomer.hasError('required')) {
                        <div class="invalid-feedback" >
                            {{ t('IDS_REQUIRED_ERROR_FIELD') }}
                        </div>
                    }
                </div>
                <div class="mt-8 pt-20">
                    <label for="delivery-date" class="form-label">{{ t('IDS_DELIVERY_DATE') }}</label>
                    <input type="text" id="delivery-date" class="form-control form-control--inverted" [class.is-invalid]="projectHeadingForm.controls.deliveryDate.invalid && (projectHeadingForm.controls.deliveryDate.dirty || projectHeadingForm.controls.deliveryDate.touched)" formControlName="deliveryDate" [placeholder]="t('IDS_DELIVERY_DATE_PLACEHOLDER')" ngbDatepicker #datePickerDeliveryForm="ngbDatepicker" (click)="datePickerDeliveryForm.toggle()">
                    @if (projectHeadingForm.controls.deliveryDate.invalid && (projectHeadingForm.controls.deliveryDate.dirty || projectHeadingForm.controls.deliveryDate.touched) && projectHeadingForm.controls.deliveryDate.hasError('required')) {
                        <div class="invalid-feedback" >
                            {{ t('IDS_REQUIRED_ERROR_FIELD') }}
                        </div>
                    } @else if (projectHeadingForm.controls.deliveryDate.invalid && (projectHeadingForm.controls.deliveryDate.dirty || projectHeadingForm.controls.deliveryDate.touched) && projectHeadingForm.controls.deliveryDate.hasError('ngbDate')) {
                        <div class="invalid-feedback" >
                            {{ t('IDS_INVALID_DATE_ERROR_FIELD') }}
                        </div>
                    }
                </div>
                <div class="my-8 pt-20">
                    <label for="note" class="form-label">{{ t('IDS_NOTES') }}</label>
                    <textarea class="form-control form-control--inverted" id="note" formControlName="note" [placeholder]="t('IDS_NOTES_PLACEHOLDER')" rows="6"></textarea>
                </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">{{ t('IDS_BUTTON_CANCEL') }}</button>
            <button type="submit" class="btn btn-primary">
                @if (action === 0) {
                    {{ t('IDS_BUTTON_CREATE') }}
                } @else {
                    {{ t('IDS_EDIT') }}
                }
            </button>
        </div>
    </form>
</ng-container>
